import { render, staticRenderFns } from "./Page__Slice--Accordion.vue?vue&type=template&id=4b5b209d&lang=pug&"
import script from "./Page__Slice--Accordion.vue?vue&type=script&lang=js&"
export * from "./Page__Slice--Accordion.vue?vue&type=script&lang=js&"
import style0 from "./Page__Slice--Accordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports